<section id="fire-item-code-maintenance">
    <div class="mtn-container">
        <div class="mtn-title">
            <p>{{ moduleName }}</p>
        </div>

        <osp-table [tblConfig]="table" (onRowClick)="onRowClick($event)" [selectedRow]="selectedRow"></osp-table>

        <div class="form-content" [hidden]="formHider">

            <form [formGroup]="form" class="form">
                <div id="fire-item-code-error-message"></div>
                <div class="form-container-grid">
                    
                    <div class="field required">
                        <label>Item Code</label>
                    </div>
                    <div class="">
                        <input formControlName="ITEM_CD">
                    </div>

                    <div class="field">
                    </div>
                    <div class="">
                    </div>
                    
                    <div class="field required">
                        <label>Short Description</label>
                    </div>
                    <div class="">
                        <input formControlName="ITEM_SHORT_DESC" maxlength="500">
                    </div>
                    
                    <div class="field required">
                        <label>Active</label>
                    </div>
                    <div class="">
                        <select formControlName="ACTIVE_TAG">
                            <option value="A">Yes</option>
                            <option value="I">No</option>
                        </select>
                    </div>
                    
                    <div class="field required">
                        <label>Long Description</label>
                    </div>
                    <div class="span">
                        <input formControlName="ITEM_LONG_DESC" maxlength="1000">
                    </div>
                    
                    <div class="field required">
                        <label>BPIMS Code</label>
                    </div>
                    <div class="">
                        <input formControlName="BM_CODE" maxlength="8">
                    </div>
                    
                    <div class="field required">
                        <label>BPIMS Item Code</label>
                    </div>
                    <div class="">
                        <input formControlName="BM_ITEM_CODE" maxlength="20">
                    </div>
                    
                    <div class="field required">
                        <label>Item Label</label>
                    </div>
                    <div class="">
                        <input formControlName="ITEM_LABEL" maxlength="1000">
                    </div>
                    
                    <div class="field required">
                        <label>Item Group</label>
                    </div>
                    <div class="">
                        <select formControlName="ITEM_GRP">
                            <option *ngFor="let itemGrp of itemGrp" [value]="itemGrp.rvLowValue">{{ itemGrp.rvMeaning }}</option>
                        </select>
                    </div>
                    
                    <div class="field">
                        <label>Item Code Detail</label>
                    </div>
                    <div class="span">
                        <textarea formControlName="ITEM_CD_DTL" maxlength="2000"></textarea>
                    </div>
                    
                    <div class="field">
                        <label>Remarks</label>
                    </div>
                    <div class="span">
                        <input formControlName="REMARKS" maxlength="1000">
                    </div>

                    <div class="field">
                        <label>Last Update User</label>
                    </div>
                    <div class="">
                        <input formControlName="USER_ID">
                    </div>

                    <div class="field">
                        <label>Last Update</label>
                    </div>
                    <div class="">
                        <input formControlName="LAST_UPDATE">
                    </div>
                </div>
            </form>

            <div class="btn-row">
                <button type="button" class="btn btn2" [hidden]="!addUpdateFlag" (click)="addRow()">ADD</button>
                <button type="button" class="btn btn2" [hidden]="addUpdateFlag" (click)="onUpdate()">UPDATE</button>
                <button type="button" class="btn btn2" [disabled]="deleteDisabler" (click)="deleteRow()">DELETE</button>
            </div>
            <div class="mtn-title"></div>
            <div class="btn-row">
                <button type="button" class="btn btn2" [disabled]="saveDisabler" (click)="onSave()">SAVE</button>
            </div>
        </div>
    </div>
</section>